module.exports = __webpack_public_path__ + "img/ic_pay2.ed3537ba.png";